import React from "react";

const Header = () => {
  return (
    <header>
      <h1>NUMBER SYSTEM CONVERSION</h1>
    </header>
  );
};

export default Header;
